import { Component, inject } from "@angular/core";
import { TourService } from "ngx-ui-tour-core";
import { TourMatMenuModule } from "ngx-ui-tour-md-menu";

@Component({
    selector: "zx-ui-tour",
    templateUrl: "./zx-ui-tour.component.html",
    styleUrls: ["./zx-ui-tour.component.scss"],
    imports: [TourMatMenuModule]
})
export class ZxUITourComponent {
    tourService = inject(TourService);
}
